import { makeStyles } from '@material-ui/core'
import Upload from 'src/assets/My_Policies_Images/Upload.svg'
import Info from 'src/assets/My_Policies_Images/Info.svg'
import { Tooltip, Zoom } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import { useHistory } from 'react-router-dom'
import { scrollToTop } from 'src/utils/commonMethods'
import { UploadPoliciesData } from 'src/utils/constants/MyPoliciesData'
import { INSURANCE_POLICIES_LIST } from 'src/utils/constants/common'
import { useDispatch, useSelector } from 'react-redux'
import { updateBuyPolicyTitle } from 'src/actions'
import {
  CLIENT,
  CLIENT_SMALLCASE,
  POLICY_DOCUMENT,
} from 'src/utils/constants/Individual'
import { invokeAllTypesSXP } from 'src/services/individualService'
import keycloak from 'src/utils/commonMethods/keycloak'

const UploadPolicyTile = ({ data, path, clientId, policyType, policyData }) => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  const reDirectBuy = () => {
    if (data?.redirectionUrl) {
      history.push(`/individual/dashboard/buyPolicy/${data?.redirectionUrl}`)
    }
    scrollToTop()
  }

  const reDirectLife = () => {
    dispatch(updateBuyPolicyTitle(INSURANCE_POLICIES_LIST?.LIFE_INSURANCE))
    history.push('/individual/dashboard/buyPolicy/life')
  }

  const { userInfo } = useSelector((state) => {
    return {
      userInfo: state?.userInfo,
    }
  })

  const getClientId = () => {
    if (clientId) {
      return clientId
    }
    return userInfo?.userInfo?.userData?.mobileNumber
  }

  const sxpBody = {
    state: {
      clientId: getClientId(),
      clientType: userInfo?.userInfo?.userData?.policyHolderType,
      documentType: POLICY_DOCUMENT,
      createdBy: userInfo?.userName,
      updatedBy: userInfo?.userName,
      email: userInfo?.userInfo?.userData?.emailId,
      token: keycloak?.token,
      roles: userInfo?.userInfo?.userData?.roles,
      policy: policyData,
      url: path,
      policyType: policyType,
      clientTypeUrl:
        userInfo?.userInfo?.userData?.policyHolderType === CLIENT?.CORPORATE
          ? CLIENT_SMALLCASE?.CORPORATE
          : CLIENT_SMALLCASE?.INDIVIDUAL,
    },
    userId: userInfo?.userName,
  }
  const invokeSxp = (key) => {
    invokeAllTypesSXP(sxpBody, userInfo?.userName, key)
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.uploadTileContainer}>
        {data?.icon ? (
          <img
            src={data?.icon}
            alt='Insurance'
            className={classes.insuranceIcon}
          />
        ) : null}
        <div className={classes.labelText}>{data?.label}</div>
        <div className={classes.uploadPolicyContainer}>
          <img
            src={Upload}
            alt='Upload'
            id='uploadIcon'
            className={classes.uploadIcon}
            onClick={() => invokeSxp('uploadIndividual')}
          />
          <div className={classes.uploadTextContainer}>
            <span
              id='uploadPolicy'
              className={classes.uploadText}
              onClick={() => invokeSxp('uploadIndividual')}
            >
              Upload Policy
            </span>
            <Tooltip
              TransitionComponent={Zoom}
              placement='bottom'
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: `${COLORS.WHITE} !important`,
                    fontSize: '12px',
                    color: `${COLORS.BLACK} !important`,
                    padding: '20px',
                    textAlign: 'center',
                    boxShadow: ' 10px 10px 30px  rgba(0, 0, 0, 0.7)',
                    borderRadius: '10px',
                    maxWidth: 200,
                  },
                },
                arrow: {
                  sx: {
                    color: `${COLORS.WHITE} !important`,
                  },
                },
              }}
              title={
                <div className={classes.toolTipContainer}>
                  <span className={classes.toolTipText}>
                    Got {data?.label} ?
                  </span>
                  <span className={classes.toolTipText}>
                    Click &quot;<b>Upload Policy</b>&quot; to store and get
                    personalized alerts.
                  </span>
                </div>
              }
              arrow
            >
              <img src={Info} alt='Info' className={classes.infoIcon} />
            </Tooltip>
          </div>
        </div>
        {!data?.hideBuy && (
          <>
            <div className={classes.orText}>Or</div>
            <div
              className={classes.buyPolicyText}
              id='buyPolicyText'
              onClick={
                data?.label === UploadPoliciesData?.[3]?.label
                  ? reDirectLife
                  : reDirectBuy
              }
            >
              Buy Policy
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default UploadPolicyTile

const useStyles = makeStyles({
  mainContainer: {
    border: '1px solid #D4D4D4',
    borderRadius: '10px',
    height: '100%',
  },
  uploadTileContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    padding: '10px 30px',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100% - 20px)',
  },
  labelText: {
    fontSize: '15px',
    fontWeight: 'bold',
  },
  uploadPolicyContainer: {
    background: '#F0F0F0',
    padding: '16px',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  uploadIcon: {
    height: '49px',
    width: '49px',
    cursor: 'pointer',
  },
  uploadTextContainer: {
    display: 'flex',
    gap: '5px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadText: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#B92250',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  infoIcon: {
    height: '13px',
    width: '13px',
  },
  orText: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  buyPolicyText: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#B92250',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  toolTipContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  toolTipText: {
    fontSize: '12px',
  },
})
